

import React, { Fragment } from 'react';
import './Contact.scss';
import { OpenExternalLink } from '../../Utilities';
import { instagramLink, linkedinLink, mailLink } from '../../Constants';

export default function Contact() {
    return (
        <Fragment>
            <div className='connect-container contact-corners'>
                <img className='right-ellipse' src="assets/images/connect/right_ellipse_dual.png" alt="ellipse_right" width={"100%"} />
                <div className='contact-corners-border-btm' />
                <div className='connect-contact'>
                    {/* <div className='mood-smile'>In the mood to smile?</div> */}
                    {/* <div className='lets-talk'>Lets connect</div> */}
                    <div className='mood-smile'>Lets connect</div>
                </div>
                <div className='connect-info'>
                    <div className='connect-title'>FOR NEW BUSINESS AND ENQUIRIES:</div>
                    <div className='connect-desc' onClick={() => { OpenExternalLink(mailLink, true) }} >{mailLink}</div>
                    <div className='connect-title'>INSTAGRAM:</div>
                    <div className='connect-desc' onClick={() => { OpenExternalLink(instagramLink, false) }} >Stories by Meet Sampat</div>
                    <div className='connect-title'>LINKEDIN:</div>
                    <div className='connect-desc' onClick={() => { OpenExternalLink(linkedinLink, false) }} >Meet Sampat</div>
                </div>
            </div>
        </Fragment>
    );
}
